// Vault Shared Utilities and Constants
import { 
  Landmark, FileText, TrendingUp, Shield, Bitcoin, Building, BarChart3, MoreHorizontal 
} from 'lucide-react';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Vault Categories Configuration
export const vaultCategories = [
  { id: 'banks', icon: Landmark, label: 'Banks', color: 'blue', description: 'Bank accounts & details' },
  { id: 'wills', icon: FileText, label: 'Wills', color: 'amber', description: 'Will documents' },
  { id: 'mutual_funds', icon: TrendingUp, label: 'Mutual Funds', color: 'emerald', description: 'MF investments' },
  { id: 'insurance', icon: Shield, label: 'Insurance', color: 'purple', description: 'Insurance policies' },
  { id: 'crypto', icon: Bitcoin, label: 'Crypto', color: 'orange', description: 'Cryptocurrency assets' },
  { id: 'property', icon: Building, label: 'Property', color: 'cyan', description: 'Real estate holdings' },
  { id: 'demat', icon: BarChart3, label: 'Demat', color: 'pink', description: 'Stock holdings' },
  { id: 'others', icon: MoreHorizontal, label: 'Others', color: 'slate', description: 'Other assets' },
];

// Color Classes for Categories
export const colorClasses = {
  blue: { bg: 'bg-blue-500/10', text: 'text-blue-400', border: 'border-blue-500/30', hover: 'hover:border-blue-500' },
  amber: { bg: 'bg-amber-500/10', text: 'text-amber-400', border: 'border-amber-500/30', hover: 'hover:border-amber-500' },
  emerald: { bg: 'bg-emerald-500/10', text: 'text-emerald-400', border: 'border-emerald-500/30', hover: 'hover:border-emerald-500' },
  purple: { bg: 'bg-purple-500/10', text: 'text-purple-400', border: 'border-purple-500/30', hover: 'hover:border-purple-500' },
  orange: { bg: 'bg-orange-500/10', text: 'text-orange-400', border: 'border-orange-500/30', hover: 'hover:border-orange-500' },
  cyan: { bg: 'bg-cyan-500/10', text: 'text-cyan-400', border: 'border-cyan-500/30', hover: 'hover:border-cyan-500' },
  pink: { bg: 'bg-pink-500/10', text: 'text-pink-400', border: 'border-pink-500/30', hover: 'hover:border-pink-500' },
  slate: { bg: 'bg-slate-500/10', text: 'text-slate-400', border: 'border-slate-500/30', hover: 'hover:border-slate-500' },
};

// Shared CSS Classes for Forms
export const inputClass = "bg-slate-800 border-slate-700 text-white placeholder:text-slate-500 focus:border-amber-500 focus:ring-amber-500/20";
export const selectClass = "bg-slate-800 border-slate-700 text-white w-full p-2 rounded-md focus:border-amber-500";
export const labelClass = "text-slate-300 font-medium text-sm";

// Utility Functions
export const getAuthHeader = () => {
  const token = localStorage.getItem('clientToken');
  return { Authorization: `Bearer ${token}` };
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
